import { defineMessages } from "react-intl";

export default defineMessages({
  totalByHour: {
    id: "orderDescription.totalByHour",
    defaultMessage: "Total / hour",
  },
  totalByDay: {
    id: "orderDescription.totalByDay",
    defaultMessage: "Total / day",
  },
  totalByWeek: {
    id: "orderDescription.totalByWeek",
    defaultMessage: "Total / week",
  },
  total: {
    id: "orderDescription.total",
    defaultMessage: "Total",
  },
  otherExpenses: {
    id: "orderDescription.otherExpenses",
    defaultMessage: "Other expenses",
  },
  monthly_subscription: {
    id: "orderDescription.monthly_subscription",
    defaultMessage: "Monthly subscription",
  },
  quarterly_subscription: {
    id: "orderDescription.quarterly_subscription",
    defaultMessage: "Quarterly subscription",
  },
  yearly_subscription: {
    id: "orderDescription.yearly_subscription",
    defaultMessage: "Yearly subscription",
  },
  remove: {
    id: "remove.product",
    defaultMessage: "(Remove)",
  },
  spOffer: {
    id: "orderDescription.spOffer",
    defaultMessage: "{serviceProviderName}'s offer",
  },
  flat: {
    id: "orderDescription.fixRate",
    defaultMessage: "Fix rate",
  },
  hour: {
    id: "orderDescription.hourlyRate",
    defaultMessage: "Hourly rate",
  },
  day: {
    id: "orderDescription.dailyRate",
    defaultMessage: "Daily rate",
  },
  serviceFee: {
    id: "orderDescription.serviceFee",
    defaultMessage: "Service fees",
  },
  flatRateFee: {
    id: "orderDescription.flatRateFee",
    defaultMessage: "{ feeRate }% on Fix rate",
  },
  hourlyRateFee: {
    id: "orderDescription.hourlyRateFee",
    defaultMessage: "{ feeRate }% on Hourly rate",
  },
  dailyRateFee: {
    id: "orderDescription.dailyRateFee",
    defaultMessage: "{ feeRate }% on Daily rate",
  },
  otherExpensesFee: {
    id: "orderDescription.otherExpensesFee",
    defaultMessage: "{ feeRate }% on Other expenses",
  },
  ringtwiceCredits: {
    id: "orderDescription.ringtwiceCredits",
    defaultMessage: "Ring Twice credits",
  },
  promoCodes: {
    id: "orderDescription.promoCodes",
    defaultMessage: "Promo code",
  },
  advancePayment: {
    id: "orderDescription.advancePayment",
    defaultMessage: "Advance payment",
  },
  youSaved: {
    id: "orderDescription.youSaved",
    defaultMessage: "You saved { amountSaved }",
  },
  youSavedTooltipMessage: {
    id: "orderDescription.youSavedTooltipMessafe",
    defaultMessage:
      "With your Ring Twice+ subscription you do not pay the 20% service fee ({ amountSaved }) on the service amount.",
  },
  mydashboard: {
    id: "order.mydashboard",
    defaultMessage: "My dashboard",
  },
  ordePaidMessage: {
    id: "order.ordePaidMessage",
    defaultMessage:
      "This order has already been paid for, you don't have to do anything more!",
  },
});
